import React from 'react';

interface LoadingProps {
  fullscreen?: boolean;
  text?: string;
  size?: 'sm' | 'md' | 'lg';
}

const Loading: React.FC<LoadingProps> = ({ 
  fullscreen = false, 
  text,
  size = 'md' 
}) => {
  const spinnerSizes = {
    sm: 'w-8 h-8 border-[3px]',
    md: 'w-14 h-14 border-[4px]',
    lg: 'w-16 h-16 border-[5px]'
  };

  const containerClasses = fullscreen 
    ? 'fixed inset-0 bg-white flex flex-col items-center justify-center z-[9999]'
    : 'flex flex-col items-center justify-center p-8';

  return (
    <div className={containerClasses}>
      <div 
        className={`${spinnerSizes[size]} rounded-full border-gray-300 border-t-[#2d5a2d] animate-spin`}
      />
      {text && (
        <p className="mt-4 text-[#2d5a2d] font-body text-sm tracking-wide">{text}</p>
      )}
    </div>
  );
};

export default Loading;
